import gql from 'graphql-tag';
import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import { useSelector, useDispatch, useI18n } from '~Hooks';

const CREATE_ID_MUTATION = gql`
  mutation createOrderEasyId($venueId: String!) {
    createOrderEasyId(venueId: $venueId) {
      orderEasyId
      success
    }
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 6;
  color: #fff;
  background: #eef1f1;
  backdrop-filter: blur(0px);
  opacity: 0;
  text-align: center;
  animation: fade-and-blur-in 650ms cubic-bezier(0, 1.08, 0.37, 0.97);
  animation-fill-mode: forwards;
  padding-top: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

const Header = styled.div`
  color: rgb(0, 107, 74);
  font-family: Oswald-Bold;
  font-size: 96px;
  font-weight: bold;
  letter-spacing: 0.2px;
  line-height: 96px;
  text-align: center;
  text-transform: uppercase;
  width: 1008px;
  margin-bottom: 32px;
`;

const SubHeader = styled.div`
  color: rgb(1, 76, 55);
  font-family: RobotoMono-Regular;
  font-size: 24px;
  font-weight: normal;
  height: 64px;
  letter-spacing: 0.2px;
  line-height: 32px;
  text-align: center;
  width: 752px;
  margin-bottom: 168px;
`;

const OrderNumberContainer = styled.div`
  background: rgb(255, 255, 255);
  border-radius: 4px;
  height: 384px;
  width: 752px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OrderNumber = styled.div`
  color: rgb(0, 107, 74);
  font-family: Oswald-Bold;
  font-size: 180px;
  font-weight: bold;
  height: 224px;
  letter-spacing: 0.38px;
  line-height: 224px;
  text-align: center;
  padding-bottom: 20px;
`;

const NewOrderBtn = styled.div`
  border-radius: 8px;
  border: 1px solid #e0e3e3;
  text-transform: uppercase;
  background: #006b4a;
  padding: 36px 52px;
  text-align: center;
  margin: 8px;
  color: #fff;
  font-size: 34px;
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 30px;
  margin-top: auto;
  margin-bottom: 110px;
  font-family: 'Oswald', sans-serif;
`;

interface Props {
  orderNumber: string | undefined | null;
  done: () => void;
}

const OrderDisplay: React.FunctionComponent<Props> = ({ orderNumber, done }) => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <Header>{i18n('Express.OrderNumber.Title')}</Header>
      <SubHeader>{i18n('Express.OrderNumber.SubTitle')}</SubHeader>
      <OrderNumberContainer>
        <OrderNumber>{orderNumber}</OrderNumber>
      </OrderNumberContainer>
      <NewOrderBtn onTouchStart={done}>{i18n('Express.OrderNumber.NewOrder')}</NewOrderBtn>
    </Wrapper>
  );
};

export default OrderDisplay;
